/* Nøste cart-formatter shim — fixes `GÅ TIL KASSE • NOK` bug.

   The Pipeline theme's bundled `themeVendor.themeCurrency.formatMoney`
   only handles 4 placeholder tokens: `amount`, `amount_no_decimals`,
   `amount_with_comma_separator`, `amount_no_decimals_with_comma_separator`.
   The Nøste shop is configured with `money_format =
   {{ amount_no_decimals_with_space_separator }}`, which the bundled
   formatter does not recognise — it falls through the switch with
   value = "" and the cart JS then writes `"" + " NOK"` into
   `[data-cart-final]`.

   We cannot monkey-patch formatMoney directly because the
   `themeCurrency` namespace is Object.frozen in vendor.js. Instead we
   mutate `window.theme.moneyFormat` (a plain inline-defined object) to
   use a supported token, then post-process the rendered amount to
   restore the space thousands separator Nøste wants.

   This shim runs as a defer script *after* vendor.js + theme.js parse
   but *before* DOMContentLoaded, so all cart event handlers see the
   patched moneyFormat. */

(function () {
  var BAD = 'amount_no_decimals_with_space_separator';
  var GOOD = 'amount_no_decimals';
  if (window.theme && typeof window.theme.moneyFormat === 'string' &&
      window.theme.moneyFormat.indexOf(BAD) !== -1) {
    window.theme.moneyFormat = window.theme.moneyFormat.replace(BAD, GOOD);
  }

  // Restore space thousands separator on cart-final + free-shipping spans.
  // formatMoney with amount_no_decimals defaults to comma thousands ("2,686"),
  // so swap commas → spaces in the leading numeric group.
  function reformat(el) {
    if (!el) return;
    var txt = el.textContent || '';
    // Match e.g. "2,686 NOK" or "12,345 NOK" with optional leading whitespace.
    var m = txt.match(/^(\s*)([\d,]+)(\s+\S.*)$/);
    if (!m) return;
    var digitsRaw = m[2];
    if (digitsRaw.indexOf(',') === -1) return;
    var swapped = digitsRaw.replace(/,/g, ' ');
    if (swapped === digitsRaw) return;
    el.textContent = m[1] + swapped + m[3];
  }
  function reformatAll() {
    document.querySelectorAll(
      '[data-cart-final], [data-cart-message] .money, [data-cart-bar] .money'
    ).forEach(reformat);
  }
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t && t.closest && t.closest('[data-cart-final], [data-cart-message]')) {
        reformat(t.closest('[data-cart-final], [data-cart-message]'));
      }
    }
  });
  function watchAll() {
    document.querySelectorAll('[data-cart-final], [data-cart-message]').forEach(function (el) {
      observer.observe(el, { childList: true, characterData: true, subtree: true });
    });
    reformatAll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchAll);
  } else {
    watchAll();
  }
})();
